"use strict";
/*
 * Created on 06.04.2021
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Extension of promotion performance report row for purpose of export of report.
 *
 * @author Tomas Leity
 */


var PromotionPerformanceRowSupplierInfo =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromotionPerformanceRowSupplierInfo, _DomainObject_1$Domai);

  /**
   * @param supplierId
   * @param preferred
   * @param promoVolume
   */
  function PromotionPerformanceRowSupplierInfo(supplierId, preferred, promoVolume) {
    var _this;

    _classCallCheck(this, PromotionPerformanceRowSupplierInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceRowSupplierInfo).call(this));
    _this.supplierId = supplierId;
    _this.preferred = preferred;
    _this.promoVolume = promoVolume;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(PromotionPerformanceRowSupplierInfo, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new PromotionPerformanceRowSupplierInfo(mat.supplierId, mat.preferred, mat.promoVolume);
    }
  }]);

  return PromotionPerformanceRowSupplierInfo;
}(DomainObject_1.DomainObject);

exports.PromotionPerformanceRowSupplierInfo = PromotionPerformanceRowSupplierInfo;

PromotionPerformanceRowSupplierInfo.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromotionPerformanceRowSupplierInfo.name);
  return {
    supplierId: builder.str('supplierId'),
    preferred: builder.bool('preferred'),
    promoVolume: builder.bigNum('promoVolume')
  };
}();